const inboxFolderSelector = (state) => (String(state.router.location.pathname).includes('/inbox') ? String(state.router.location.pathname || '').split('/')[3] || 'inbox' : '');

export default inboxFolderSelector;
